import React from "react";

const Vision = () => {
    return (
        <>
            This is Vision Page
        </>
    );
};

export default Vision;
